import React from 'react';
import { Button } from 'reactstrap';
import LocalPhoneField from './localPhoneField';

// A person's phone numbers (guard, supervisor, client): the same phone field and dialling code as before,
// once per number, with Remove next to each (when there is more than one) and "Add another number".
// The first is the main number. phones is the list as typed; onChange gets the new list.
// The person signs in to the app with any of them (the same CID whichever they use). Each box offers the
// numbers already used in the company as they are typed (LocalPhoneField suggest), leaving out the person
// being edited (editing: { kind, id }; nothing for a new person).
export default function PhoneList({ dialCode, phones, onChange, editing }) {
	const list = Array.isArray(phones) && phones.length ? phones : [''];
	const set = (index, value) => onChange(list.map((phone, i) => (i === index ? value : phone)));
	const remove = (index) => onChange(list.filter((phone, i) => i !== index));
	return (
		<div style={{ width: '100%' }}>
			{list.map((phone, index) => (
				<div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: index < list.length - 1 ? 6 : 0 }}>
					<div style={{ flex: 1 }}>
						<LocalPhoneField dialCode={dialCode} value={phone} onChange={(value) => set(index, value)} required={index === 0} suggest editing={editing} />
					</div>
					{list.length > 1 ? (
						<Button type="button" color="link" size="sm" title="Remove this number (signs out an app sign-in that used it)"
							onClick={() => remove(index)} style={{ whiteSpace: 'nowrap' }}>Remove</Button>
					) : null}
				</div>
			))}
			<Button type="button" color="link" size="sm" style={{ paddingLeft: 0 }} onClick={() => onChange(list.concat(['']))}>
				+ Add another number
			</Button>
		</div>
	);
}
